import { graphql } from "gatsby";
import React, { useEffect } from "react";

export function isDesktop() {
  return !window.matchMedia("(max-width: 768px)").matches;
}

type position = "top" | "mid" | "bottom";
interface Props {
  position: position;
  adSenseSlots: Queries.SERPPageQuery["adSenseSlots"];
  utmSource: string;
}

export default function AdSense({ adSenseSlots, position }: Props) {
  useEffect(() => {
    const p: any = {};
    (window.adsbygoogle = window.adsbygoogle || []).push(p);
  }, []);

  let slot = adSenseSlots[position];
  if (isDesktop() && adSenseSlots.desktop[position]) {
    slot = adSenseSlots.desktop[position];
  }

  if (!slot) {
    return null;
  }

  return (
    <ins
      className="adsbygoogle mx-auto mt-8 block aspect-[1.2] text-center"
      data-ad-client="ca-pub-9325511402488162"
      data-ad-slot={slot}
      data-ad-layout-key={position}
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
}

export const fragments = graphql`
  fragment AdSenseSlots on AdSense {
    top
    mid
    bottom
    desktop {
      top
      mid
      bottom
    }
  }
`;
